// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-7c23a5":"c35608effbf190f8","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"3f0513d0a765a420","apps_bsa_src_app_offer_offer-wrapper_module_ts":"512db14f1540b5ff"}[chunkId] + ".js";
};